import Common from '../common/Common';
import { NETWORK } from '../common/const';
import modal from '../components/Modal';
import { getJsonp } from '../service/fetchJsonp';
import { getNotiLangCode } from '../common/const';

class NotiSetting {
    constructor(_config) {
        this.config = _config;
        this.com = Common.instance;
        this.container = document.querySelector('#notiSetting');
        this.isLoading = false;

        this.userDataLocale = getNotiLangCode();
        
        const { env } = this.com || {};
        const rcPrefix = [NETWORK.rc].includes(env) ? 'rc-' : '';

        let thisSiteNum = {
            lineage: '27',
            bns: '24',
            aion: '26',
            rk: '178'
        };
        this.prior = thisSiteNum[this.config.userData.site] || '';

        let nowDomain = /(asia\.nc\.com)/i.test(location.href) ? 'asia.nc.com' : 'noti.plaync.com';
        this.api = {
            list: `${location.protocol}//${rcPrefix}${nowDomain}/noti/api/common/getReceiveSetting.jsonp`,
            reject: `${location.protocol}//${rcPrefix}${nowDomain}/noti/api/common/updateReceiveSetting.jsonp`,
        };

        if (env === NETWORK.opdev) {
            this.api = {
                list: 'http://ui-static.korea.ncsoft.corp/uikit/cnb/data/notisettingdummydata.json',
                reject: 'http://ui-static.korea.ncsoft.corp/uikit/cnb/data/notisettingdummydata2.json',
            };
        }
    }

    start() {
        getJsonp({
            url: this.api.list,
            params: {
                priorMainCategories: this.prior,
                language: this.userDataLocale
            }
        }).then(res => {
            const result = res?.result || {};
            const { notiResult = {} } = result;
            const temp =
                    this.tmplHeader(notiResult) +
                    this.tmplCategoryList(notiResult?.mainCategoryList) +
                    this.tmplBtns();
            this.container.innerHTML = temp;

            if (!notiResult?.receive) {
                const $dl = this.container?.querySelectorAll('dl');

                if($dl.length > 0) {
                    $dl.forEach(v => {
                        v.style.display = 'none';
                    });
                }
            }

            this.addEvents();
            if (window.ncNotice) {
                window.ncNotice.$dispatcher?.dispatchEvent(new CustomEvent('load-complete'));
            }
        })
        .catch(err => {
            console.log(`${this.api.list} 호출에 실패했습니다.`, err);
        });
    }

    addEvents() {
        const btnApply = document.querySelector('#notiSetting .wrap_btns .btnApply');
        const btnCancel = document.querySelector('#notiSetting .wrap_btns .btnCancel');
        const dtCheckbox = document.querySelectorAll('#notiSetting dl dt input[type="checkbox"]');
        const headerCheckbox = document.querySelectorAll('#notiSetting header input[type="checkbox"]');

        btnApply?.addEventListener('click', e => {
            this.apply();
        });

        btnCancel?.addEventListener('click', e => {
            this.ncNoticeStart();
        });

        if(dtCheckbox.length > 0) {
            dtCheckbox.forEach(checkbox => { 
                checkbox?.addEventListener('change', e => {
                    const tNode = e.target;
                    const dl = tNode.closest('dl');
                    const isChecked = checkbox.checked;

                    if(isChecked) {
                        dl?.classList?.add('checked');
                    } else {
                        dl?.classList?.remove('checked');
                    }

                    window.ncNotice.$dispatcher?.dispatchEvent(new CustomEvent('change-checked'));
                });
            });
        }

        if(headerCheckbox.length > 0) {
            const dl = this.container?.querySelectorAll('dl');

            headerCheckbox.forEach(checkbox => {
                checkbox?.addEventListener('change', e => {
                    const isChecked = e.target.checked;

                    if(dl.length > 0) {
                        dl.forEach(dl => {
                            dl.style.display = isChecked ? 'block' : 'none';
                        });
                    }

                    window.ncNotice.$dispatcher?.dispatchEvent(new CustomEvent('change-checked'));
                });
            });
        }
    }

    apply() {
        if (this.isLoading) return;
        const elList = document.querySelectorAll('#notiSetting input[type="checkbox"]');
        const elListLng = elList.length;
        let list = [];

        if(elListLng > 0) {
            elList.forEach((it, idx) => {
                const isChecked = it.checked;
                
                if (!isChecked) {
                    list.push(it.id);
                }
            });
        }

        getJsonp({
            url: this.api.reject,
            params: {
                rejectedCategories: list.join(','),
                language: this.userDataLocale
            }
        })
        .then(res => {
            const result = res?.result || {};

            if (result?.returnMessage === 'SUCCESS') {
                this.tmplSettingCompleteMsg(result);
            } else {
                this.tmplSettingErrorMsg();
            }
        })
        .catch(err => {
            console.log(`${this.api.reject + '?rejectedCategories=' + list} 호출에 실패했습니다.`, err);
        });
    }

    tmplHeader(_data) {
        let templ = `
        <header class="setAll">
            <input type="checkbox" id="${_data.allCategoryNo}" ${_data.receive? 'checked': ''} />
            <label for="${_data.allCategoryNo}">${_data.title}</label>
            <p class="desc">${_data.tooltip}</p>
        </header>`;
        return templ;
    }

    tmplCategoryList(_data) {
        let temp = '';
        for (let i = 0; i < _data.length; i++) {
            temp += this.tmplCategory(_data[i]);
        }
        return temp;
    }

    tmplCategory(_data) {
        let templ = `
        <dl class="setDetail checked">
            <dt>
                <input type="checkbox" id="${_data.mainCategoryNo}" ${_data.receive ? 'checked' : ''} /> 
                <label for="${_data.mainCategoryNo}">${_data.title} ${this.com.l10nData.Notifications.Notifications}</label>
            </dt>
            ${_data.subCategoryList.map(it=>`
                <dd>
                    <input type="checkbox" id="${it.subCategoryNo}" ${it.receive ? 'checked' : ''}> 
                    <label for="${it.subCategoryNo}" title="${it.tooltip}">${it.title}</label>
                </dd>
            `).join('')}
        </dl>
        `
        return templ;
    }

    tmplBtns() {
        return `<div class="wrap_btns">
            <button class="imgBtn btnApply">${this.com.l10nData.Notifications.btn_confirm}</button>&nbsp;
            <button class="imgBtn btnCancel">${this.com.l10nData.Notifications.btn_cancel}</button>
        </div>`;
    }

    async tmplSettingCompleteMsg(result = {}) {
        const { notiResult } = result;
        const { serverMillisec, adReceiveList, adRejectList } = notiResult || {};
        const Notifications = this.com.l10nData.Notifications;
        const dd = new Date(Number(serverMillisec));
        const dateStr = dd.toLocaleString(document.documentElement.lang) + ',\n';
        let str = dateStr + Notifications?.NotiSettingsChanged;
        let recList = adReceiveList;
        let rejList = adRejectList;
        let recStr = Notifications?.AgreedToReceiveAdvertisements;
        let rejStr = Notifications?.WithdrawnFromAgreementReceiveAdvertisements;
        let recTmp = '';
        let rejTmp = '';

        if (recList?.length > 0) {
            recTmp += '\n\n';
            for (let i = 0; i < recList.length; i++) {
                const item = recList[i];
                recTmp += `${(i == 0 ? '' : '/')}${item.mainCategory}-${item.subCategory}`;
            }
            recTmp += recStr;
        }

        if (rejList?.length > 0) {
            rejTmp += '\n\n';
            for (let i = 0; i < rejList.length; i++) {
                const item = rejList[i];
                rejTmp += `${(i == 0 ? '' : '/')}${item.mainCategory}-${item.subCategory}`;
            }
            rejTmp += rejStr;
        }

        str += recTmp + rejTmp;

        await modal.openAlert({ title: str });
        this.ncNoticeStart();
    }

    async tmplSettingErrorMsg() {
        let str = this.com.l10nData.Notifications.ProcessisDelayed;
        await modal.openAlert({ title: str });
    }

    ncNoticeStart() {
        if (window.ncNotice) {
            const notiSetting = document.querySelector('#notiSetting');
            const notiList = document.querySelector('#notiList');

            if(notiSetting) notiSetting.style.display = 'none';
            if(notiList) notiList.style.display = 'block';
            window.ncNotice.start();
        }
    }
}

export default NotiSetting;